import createApp from './app.js'

import authService from './service.auth.js'
import firestoreService from './service.firestore.js'
import functionsService from './service.functions.js'
import messagingService from './service.messaging.js'

const appConfig = {"apiKey":"AIzaSyCW5QCoWP1fIR5Dzydsh5Lct-Zr2KhGB_Y","authDomain":"careecon-for-work-sekou-dev.firebaseapp.com","databaseURL":"https:\u002F\u002Fcareecon-for-work-sekou-dev.firebaseio.com","projectId":"careecon-for-work-sekou-dev","storageBucket":"careecon-for-work-sekou-dev.appspot.com","messagingSenderId":"75421377881","appId":"1:75421377881:web:b052794968c7d233c69848","measurementId":"G-TQV7MGCCXR"}

export default async (ctx, inject) => {
  /****************************************
  **************** LAZY MODE **************
  ****************************************/

  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
    firestoreService(session, firebase, ctx, inject),
    functionsService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      firestoreService(session, firebase, ctx, inject),
      functionsService(session, firebase, ctx, inject),
      messagingService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    firestore,
    functions,
    messaging
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    firestore: firestore,
    functions: functions,
    messaging: messaging
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}
